import React,{useState} from 'react'
import {
   Box, Container, Grid, Card, Typography, TextField, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Avatar, IconButton, Pagination, Select, InputLabel, FormControl, Tooltip,
  CssBaseline, Dialog, DialogTitle, DialogContent,
  DialogActions, Button, Stack
} from "@mui/material";
import { Delete, Edit,Visibility, Lock } from '@material-ui/icons';

function UsersManagment() {
  // --- MANUAL USERS DATA ---
  const usersData = [
    { id: 1, name: "John Doe", Vendor: "Acme Corp", role: "Admin", status: "active", avatarUrl: "https://i.pravatar.cc/150?img=1" },
    { id: 2, name: "Alice Smith", Vendor: "Acme Corp", role: "User", status: "active", avatarUrl: "https://i.pravatar.cc/150?img=2" },
    { id: 3, name: "David Johnson", Vendor: "Acme Corp", role: "Super-Admin", status: "banned", avatarUrl: "https://i.pravatar.cc/150?img=3" },
    { id: 4, name: "Emma Wilson", Vendor: "Acme Corp", role: "User", status: "active", avatarUrl: "https://i.pravatar.cc/150?img=4" },
    { id: 5, name: "Michael Brown", Vendor: "Acme Corp", role: "Admin", status: "banned", avatarUrl: "https://i.pravatar.cc/150?img=5" },
    { id: 6, name: "Sophia Davis", Vendor: "Acme Corp", role: "User", status: "active", avatarUrl: "https://i.pravatar.cc/150?img=6" },
    { id: 7, name: "James Miller", Vendor: "Acme Corp", role: "Super-Admin", status: "active", avatarUrl: "https://i.pravatar.cc/150?img=7" },
    { id: 8, name: "Olivia Garcia", Vendor: "Acme Corp", role: "User", status: "banned", avatarUrl: "https://i.pravatar.cc/150?img=8" },
  ];

  // --- STATES ---
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("");
  const [status, setStatus] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [page, setPage] = useState(1);
  const rowsPerPage = 5;

  // --- FILTERED USERS ---
  const filteredUsers = usersData.filter(
    (u) =>
      (search ? u.name.toLowerCase().includes(search.toLowerCase()) : true) &&
      (role ? u.role === role : true) &&
      (status ? u.status.toLowerCase() === status.toLowerCase() : true)
  );

  // --- PAGINATED USERS ---
  const paginatedUsers = filteredUsers.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  // --- HANDLERS ---
  const handleEditOpen = (user) => { setSelectedUser(user); setOpenEdit(true); };
  const handleViewOpen = (user) => { setSelectedUser(user); setOpenView(true); };
  const handleDeleteOpen = (user) => { setSelectedUser(user); setOpenDelete(true); };
  const handleClose = () => { setOpenEdit(false); setOpenView(false); setOpenDelete(false); setSelectedUser(null); };
  const handleSave = () => { console.log("Updated user:", selectedUser); setOpenEdit(false); };
  const handleDeleteConfirm = () => { console.log("Deleted user:", selectedUser); setOpenDelete(false); setSelectedUser(null); };

  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Box component="main" sx={{ flexGrow: 1, py: 3 }}>
        <Container maxWidth={false} disableGutters>

          {/* Stats Cards */}
          <Grid container spacing={3} mb={4}>
            {[
              { label: "Total Users", value: usersData.length },
              { label: "Active Users", value: usersData.filter(u => u.status === "active").length },
              { label: "Banned Users", value: usersData.filter(u => u.status === "banned").length },
              { label: "Verified", value: usersData.filter(u => u.isVerified).length },
            ].map((stat, i) => (
              <Grid item xs={12} sm={6} md={3} key={i}>
                <Card sx={{ p: 3, textAlign: "center", boxShadow: 3, background: "linear-gradient(135deg, #e0f7fa, #ffffff)" }}>
                  <Typography variant="h4" fontWeight="bold">{stat.value}</Typography>
                  <Typography variant="body2" color="textSecondary">{stat.label}</Typography>
                </Card>
              </Grid>
            ))}
          </Grid>

          {/* Filters */}
          <Grid container spacing={2} mb={3}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                placeholder="🔍 Search users..."
                variant="outlined"
                value={search}
                onChange={(e) => { setSearch(e.target.value); setPage(1); }}
              />
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="role-label">Role</InputLabel>
                <Select
                  labelId="role-label"
                  value={role}
                  label="Role"
                  onChange={(e) => { setRole(e.target.value); setPage(1); }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="User">User</MenuItem>
                  <MenuItem value="Super-Admin">Super-Admin</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                  labelId="status-label"
                  value={status}
                  label="Status"
                  onChange={(e) => { setStatus(e.target.value); setPage(1); }}
                >
                  <MenuItem value="">All</MenuItem>
                  <MenuItem value="active">✅ Active</MenuItem>
                  <MenuItem value="banned">⛔ Banned</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>

          {/* User Table */}
          <Card sx={{ borderRadius: 3, boxShadow: 3 }}>
            <TableContainer sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead sx={{ backgroundColor: "#f1f5f9" }}>
                  <TableRow>
                    <TableCell><strong>Avatar</strong></TableCell>
                    <TableCell><strong>Name</strong></TableCell>
                    <TableCell><strong>Vendor</strong></TableCell>
                    <TableCell><strong>Role</strong></TableCell>
                    <TableCell><strong>Status</strong></TableCell>
                    <TableCell><strong>Actions</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paginatedUsers.map((user) => (
                    <TableRow key={user.id} hover>
                      <TableCell><Avatar src={user.avatarUrl} alt={user.name} sx={{ width: 48, height: 48 }} /></TableCell>
                      <TableCell>{user.name}</TableCell>
                      <TableCell>{user.Vendor}</TableCell>
                      <TableCell>{user.role}</TableCell>
                      <TableCell>
                        <Typography sx={{
                          px: 1.5, py: 0.5, borderRadius: 2,
                          display: "inline-block", fontSize: "0.8rem", fontWeight: "bold",
                          color: user.status === "active" ? "green" : "red",
                          backgroundColor: user.status === "active" ? "rgba(0,128,0,0.1)" : "rgba(255,0,0,0.1)"
                        }}>{user.status}</Typography>
                      </TableCell>
                      <TableCell>
                        <Stack direction="row" spacing={1} flexWrap="wrap">
                          <Tooltip title="Edit"><IconButton sx={{ color: "#1976d2" }} onClick={() => handleEditOpen(user)}><Edit fontSize="small" /></IconButton></Tooltip>
                          <Tooltip title="Delete"><IconButton sx={{ color: "#d32f2f" }} onClick={() => handleDeleteOpen(user)}><Delete fontSize="small" /></IconButton></Tooltip>
                          <Tooltip title="Block/Unblock"><IconButton sx={{ color: "#ed6c02" }}><Lock fontSize="small" /></IconButton></Tooltip>
                          <Tooltip title="View"><IconButton sx={{ color: "#7b1fa2" }} onClick={() => handleViewOpen(user)}><Visibility fontSize="small" /></IconButton></Tooltip>
                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>

          {/* Pagination */}
          <Box display="flex" justifyContent="center" mt={3}>
            <Pagination
              count={Math.ceil(filteredUsers.length / rowsPerPage)}
              page={page}
              onChange={(e, value) => setPage(value)}
              variant="outlined"
              shape="rounded"
              color="primary"
            />
          </Box>

        </Container>
      </Box>

      {/* --- Dialogs (Edit, View, Delete) --- */}
      <Dialog open={openEdit} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Edit User</DialogTitle>
        <DialogContent dividers>
          {selectedUser && (
            <Stack spacing={2} mt={1}>
              <TextField label="Name" fullWidth value={selectedUser.name} onChange={(e) => setSelectedUser({ ...selectedUser, name: e.target.value })} />
              <FormControl fullWidth>
                <InputLabel id="edit-role-label">Role</InputLabel>
                <Select labelId="edit-role-label" value={selectedUser.role} label="Role" onChange={(e) => setSelectedUser({ ...selectedUser, role: e.target.value })}>
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="User">User</MenuItem>
                  <MenuItem value="Super-Admin">Super-Admin</MenuItem>
                </Select>
              </FormControl>
              <FormControl fullWidth>
                <InputLabel id="edit-status-label">Status</InputLabel>
                <Select labelId="edit-status-label" value={selectedUser.status} label="Status" onChange={(e) => setSelectedUser({ ...selectedUser, status: e.target.value })}>
                  <MenuItem value="active">✅ Active</MenuItem>
                  <MenuItem value="banned">⛔ Banned</MenuItem>
                </Select>
              </FormControl>
            </Stack>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave} variant="contained">Save</Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openView} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>View User</DialogTitle>
        <DialogContent dividers>
          {selectedUser && (
            <Stack spacing={2} mt={1}>
              <Typography><strong>Name:</strong> {selectedUser.name}</Typography>
              <Typography><strong>Vendor:</strong> {selectedUser.Vendor}</Typography>
              <Typography><strong>Role:</strong> {selectedUser.role}</Typography>
              <Typography><strong>Status:</strong> {selectedUser.status}</Typography>
            </Stack>
          )}
        </DialogContent>
        <DialogActions><Button onClick={handleClose}>Close</Button></DialogActions>
      </Dialog>

      <Dialog open={openDelete} onClose={handleClose} maxWidth="xs" fullWidth>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent dividers>
          {selectedUser && (<Typography>Are you sure you want to delete <strong>{selectedUser.name}</strong>?</Typography>)}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} variant="contained" color="error">Delete</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default UsersManagment;